// src/pages/Vendor/Apply/components/Step4Submitted.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Mail, Clock, ArrowRight } from 'lucide-react';

const Step4Submitted: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center py-8">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <CheckCircle className="h-10 w-10 text-green-600" />
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mb-2">Application Submitted!</h2>
      <p className="text-gray-500 mb-6 max-w-sm mx-auto">
        Thank you for applying to become a vendor. Our team will review your application shortly.
      </p>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-left max-w-sm mx-auto mb-6">
        <div className="flex items-start gap-3">
          <Mail className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-blue-900">Check Your Email</p>
            <p className="text-sm text-blue-700">
              We've sent a confirmation to your email address with next steps.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 text-sm text-gray-500 mb-6">
        <Clock className="h-4 w-4" />
        <span>Estimated review time: 1-3 business days</span>
      </div>

      <button
        onClick={() => navigate('/')}
        className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors inline-flex items-center gap-2"
      >
        Return to Home
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default Step4Submitted;